// ** saylov
const initialState = {
  saylov: false
}

const saylov = (state = initialState, action) => {
  switch (action.type) {
    case "SAYLOV":
      return { ...state, saylov: action.val }
    default:
      return state
  }
}

export default saylov
